import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACV } from 'customer-data-objects/lineItem/PropertyNames';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { LineItemsLogger } from 'customer-data-tracking/loggers';
import * as dealsAPI from 'products-ui-components/api/dealsAPI';
import { DEAL_AMOUNT_PREFERENCES } from '../constants/DealAmountOptions';
import { calculateDealAmountByPreference } from './calculations/totals';
import { areAnyLineItemCurrenciesMismatched } from './lineItemMulticurrency';
import toNumber from './toNumber';

// TODO convert to graphQL updater
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function saveDealAndTrackUsage(deal, effectiveCurrencyCode, lineItems, customDealAmount, dealAmountPreference, dealAmountPropertySource, dealAmountPropertySourceId) {
  const preferenceIsManualEntry = dealAmountPreference === DEAL_AMOUNT_PREFERENCES.disabled;
  if (areAnyLineItemCurrenciesMismatched(effectiveCurrencyCode, lineItems) ||
  // if customDealAmount is not provided, and preference is manual entry, we shouldn't save a deal amount
  preferenceIsManualEntry && customDealAmount === undefined) {
    return Promise.resolve();
  }
  const dealAmount = getProperty(deal, 'amount');
  const currentAmount = dealAmount ? toNumber(getProperty(deal, 'amount')) : dealAmount;
  const newAmount = preferenceIsManualEntry ? customDealAmount : calculateDealAmountByPreference(lineItems, dealAmountPreference, effectiveCurrencyCode).total;
  if (newAmount === currentAmount) {
    return Promise.resolve();
  }
  LineItemsLogger.log('updateDealAmount', {
    action: 'Update deal amount'
  });
  return dealsAPI.updateDealAmount(deal.dealId, newAmount != null ? String(newAmount) : null, dealAmountPropertySource, dealAmountPropertySourceId);
}
function isDealAmountPreferencesKey(maybeKey) {
  return Object.keys(DEAL_AMOUNT_PREFERENCES).includes(maybeKey);
}
export function getDealAmountPreference(dealAmountCalculationPreference, hasLegacyDealAmountCalculation) {
  const fallbackPreference = hasLegacyDealAmountCalculation ? DEAL_AMOUNT_PREFERENCES.legacy : DEAL_AMOUNT_PREFERENCES[ACV];
  return isDealAmountPreferencesKey(dealAmountCalculationPreference) ? DEAL_AMOUNT_PREFERENCES[dealAmountCalculationPreference] : fallbackPreference;
}
const DEAL_AMOUNT_SETTING_HREF = `/sales-products-settings/${PortalIdParser.get()}/deals`;
export const getDealAmountPopoverContent = dealAmountPreference => {
  const header = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "lineItems.onboarding.shepherd.dealAmount.header"
  });
  if (dealAmountPreference === 'legacy') {
    return {
      header,
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "lineItems.onboarding.shepherd.dealAmount.body"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "lineItems.onboarding.shepherd.dealAmount.legacyDealPreference"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "lineItems.onboarding.shepherd.dealAmount.adminLink",
            options: {
              href: DEAL_AMOUNT_SETTING_HREF
            }
          })
        })]
      })
    };
  }
  return {
    header,
    body: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lineItems.onboarding.shepherd.dealAmount.body"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "lineItems.onboarding.shepherd.dealAmount.adminLink",
          options: {
            href: DEAL_AMOUNT_SETTING_HREF
          }
        })
      })]
    })
  };
};